import React, { useCallback } from 'react';
import { StackLayout, Text } from '@wemogy/reactbase';
import AddressInput from '../addressInput/AddressInputComponent';
import Map from '../map/MapComponent';
var MapSearch = function (_a) {
    var center = _a.center, address = _a.address, disableFlyAnimation = _a.disableFlyAnimation, onAddressChanged = _a.onAddressChanged, loadingIndicatorRenderer = _a.loadingIndicatorRenderer;
    var handleSearchResultSelected = useCallback(function (addressResult) {
        onAddressChanged(addressResult);
    }, [onAddressChanged]);
    var handleCurrentPositionRequested = useCallback(function (currentPosition) {
        onAddressChanged({
            placeId: 'deviceLocation',
            position: currentPosition
        });
    }, [onAddressChanged]);
    var handleMarkerPositionChanged = useCallback(function (newPosition) {
        if (!address) {
            onAddressChanged({
                placeId: 'customMarkerPosition',
                position: newPosition
            });
        }
        else {
            address.position = newPosition;
            onAddressChanged(address);
        }
    }, [address, onAddressChanged]);
    return (React.createElement(StackLayout, { height: 30 },
        React.createElement(AddressInput, { specific: true, selectedAddress: address, onAddressSelected: handleSearchResultSelected }),
        React.createElement(StackLayout, { height: true }),
        React.createElement(StackLayout, { stretch: true },
            React.createElement(Map, { disableFlyAnimation: disableFlyAnimation, loadingIndicatorRenderer: loadingIndicatorRenderer, onCurrentPositionRequested: handleCurrentPositionRequested, center: (address === null || address === void 0 ? void 0 : address.position) || center, markers: address ? [{
                        position: address.position,
                        onPositionChanged: handleMarkerPositionChanged
                    }] : undefined })),
        React.createElement(StackLayout, { hEnd: true }, address ? React.createElement(Text, { noTranslation: true }, "Latitude: " + address.position.latitude + " Longitude: " + address.position.longitude) : null)));
};
export default MapSearch;
//# sourceMappingURL=MapSearch.js.map